import { render, staticRenderFns } from "./SidebarFileList.vue?vue&type=template&id=8a626294&scoped=true&"
import script from "./SidebarFileList.vue?vue&type=script&lang=js&"
export * from "./SidebarFileList.vue?vue&type=script&lang=js&"
import style0 from "./SidebarFileList.vue?vue&type=style&index=0&id=8a626294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a626294",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/stats/KiwiIRC/plugin-fileuploader/fileuploader-kiwiirc-plugin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8a626294', component.options)
    } else {
      api.reload('8a626294', component.options)
    }
    module.hot.accept("./SidebarFileList.vue?vue&type=template&id=8a626294&scoped=true&", function () {
      api.rerender('8a626294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SidebarFileList.vue"
export default component.exports